import { xySortX } from 'ml-spectra-processing';
/**
 * Builds increasing-X measurement variables for UVProbe absorbance spectra.
 * @param x - wavelength values (nm).
 * @param y - absorbance values.
 * @returns The `x`/`y` measurement variables with increasing wavelength.
 */
export function buildVariables(x, y) {
    const { x: oX, y: oY } = xySortX({ x, y });
    return {
        x: {
            symbol: 'x',
            label: 'Wavelength',
            units: 'nm',
            data: oX,
            isDependent: false,
        },
        y: {
            symbol: 'y',
            label: 'Absorbance',
            units: '',
            data: oY,
            isDependent: true,
        },
    };
}
//# sourceMappingURL=buildVariables.js.map